import { pluralizeToString } from 'lib/string/pluralize'
import React, { useCallback, useMemo } from 'react'
import RadioInput from 'LuxKit/Radio/RadioInput'
import RadioGroup from 'LuxKit/Radio/RadioGroup'
import { rem } from 'polished'
import styled from 'styled-components'

const RoomRadioGroup = styled(RadioGroup)`
  padding-left: ${rem(16)};
  padding-right: ${rem(16)};
`

interface Props {
  size?: 'medium' | 'large'
  rooms: Array<App.Occupants>
  onRoomCountChange: (roomCount: number) => void
  travellerCount: number
}

function RoomsContent({
  size = 'medium',
  travellerCount,
  rooms,
  onRoomCountChange,
}: Props) {
  // Default show 1 room to 4 rooms, adjust based on the traveller count
  // show from: traveller // 2 to traveller
  const roomOptions: Array<number> = useMemo(() => {
    const minRooms = Math.ceil(travellerCount / 2)
    const maxRooms = travellerCount
    if (maxRooms <= 4) return [1, 2, 3, 4]
    return Array.from({ length: maxRooms - minRooms + 1 }, (_, index) => index + minRooms)
  }, [travellerCount])

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const roomCount = Number(e.target.value)
    onRoomCountChange(roomCount)
  }, [onRoomCountChange])

  return (
    <RoomRadioGroup>
      {roomOptions.map((value) => (
        <RadioInput
          key={value}
          value={value.toString()}
          size={size}
          checked={rooms.length === value}
          onChange={onChange}
          disabled={travellerCount > value * 2 || value > travellerCount}
        >
          {pluralizeToString('room', value)}
        </RadioInput>
      ))}
    </RoomRadioGroup>
  )
}

export default RoomsContent
